import React, { FC } from "react";

type Props = {
  isOn: boolean;
  onSwitched: (isOn: boolean) => void;
};

const CustomSwitch: FC<Props> = ({ isOn, onSwitched }) => {
  return (
    <React.Fragment>
      <div
        className="md:hidden"
        onClick={() => onSwitched(!isOn)}
        style={{
          position: "relative",
          display: "inline-block",
          textAlign: "left",
          opacity: 1,
          direction: "ltr",
          borderRadius: "9px",
          transition: "opacity 0.25s",
          touchAction: "none",
          WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
          userSelect: "none",
        }}
      >
        <div
          className="react-switch-bg"
          style={{
            height: "18px",
            width: "40px",
            margin: "0px",
            position: "relative",
            background: isOn ? "rgb(0, 109, 115)" : "rgb(136, 136, 136)",
            borderRadius: "9px",
            cursor: "pointer",
            transition: "background 0.25s",
          }}
        >
          <div
            style={{
              height: "18px",
              width: "27px",
              position: "relative",
              opacity: isOn ? 1 : 0,
              pointerEvents: "none",
              transition: "opacity 0.25s",
            }}
          >
            <svg
              height="100%"
              width="100%"
              viewBox="-2 -5 17 21"
              style={{ position: "absolute", top: "0px" }}
            >
              <path
                d="M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0"
                fill="#fff"
                fillRule="evenodd"
              />
            </svg>
          </div>
          <div
            style={{
              height: "18px",
              width: "27px",
              position: "absolute",
              opacity: isOn ? 0 : 1,
              right: "0px",
              top: "0px",
              pointerEvents: "none",
              transition: "opacity 0.25s",
            }}
          >
            <svg
              viewBox="-2 -5 14 20"
              height="100%"
              width="100%"
              style={{ position: "absolute", top: "0px" }}
            >
              <path
                d="M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12"
                fill="#fff"
                fillRule="evenodd"
              />
            </svg>
          </div>
        </div>
        <div
          className="react-switch-handle"
          style={{
            height: "6px",
            width: "6px",
            background: "rgb(245, 245, 245)",
            display: "inline-block",
            cursor: "pointer",
            borderRadius: "50%",
            position: "absolute",
            transform: isOn ? "translateX(28px)" : "translateX(6px)",
            top: "6px",
            outline: "0px",
            border: "0px",
            transition:
              "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
          }}
        />
        <input
          type="checkbox"
          role="switch"
          checked={isOn}
          onChange={() => onSwitched(!isOn)}
          aria-checked={isOn}
          style={{
            border: "0px",
            clip: "rect(0px, 0px, 0px, 0px)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: "0px",
            position: "absolute",
            width: "1px",
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default CustomSwitch;
